<div class="main-content">
  <div class="container-fluid container-fluid-dialog">
    <div class="card card-inside card-inside-dialog">
      <div class="card-header card-header-danger">
        <div class="row">
          <div class="col mt5">
            <h4 class="card-title mt-0">{{'İşlem Onay Ekranı'|translate}}</h4>
          </div>
        </div>
      </div>
      <div class="card-body table-responsive">
        <div class="col-12">
          <div class="row">
            <p class="lead" *ngIf="message">{{message}}</p>
          </div>
        </div>
        <div class="col-12" style="display: flex; justify-content: space-between;">
            <button [disabled]="isLoading" mat-raised-button class="mr-2" color="link" (click)="confirm()">
              <mat-icon>check</mat-icon>
              {{'ONAYLA'|translate}}
            </button>
            <button mat-raised-button color="warn" (click)="reject()">
              <mat-icon>clear</mat-icon>
              {{'REDDET'|translate}}
            </button>
        </div>
      </div>
    </div>
  </div>
</div>
